// extracted by mini-css-extract-plugin
export default {"root":"SelectSingleFilter_root__R+dZC","labelPlain":"SelectSingleFilter_labelPlain__fChwo","labelPlainSelected":"SelectSingleFilter_labelPlainSelected__aGQyC"};